// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.rule-dialog-box {\n  height: 64%;\n  min-height: 500px;\n}\n.rule-dialog-box .el-dialog__body {\n  height: 75%;\n  overflow-y: scroll;\n  padding-top: 0;\n}\n.rule-cont-list {\n  line-height: 28px;\n}\n.rule-cont-list p {\n  width: 100%;\n}\n.rule-cont-list h2 {\n  margin: 20px 0 10px 0;\n}\nh2, b {\n  font-weight: bolder;\n}\n.retract {\n  text-indent: 15px;\n}\n.retract2 {\n  text-indent: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
